// Global default for how many products render in a single marketplace product list/grid.
// Marketplace pages (Posters, Physical Edition, ...) can override this by setting
// resolveListMaxItems() falls back to the value below.
export const marketplaceListConfig = {
  maxItems: 12,
};

export default marketplaceListConfig;
